import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../../theme';

const detailsPadding = ({ theme }: { theme: Theme }) =>
    theme.tggSpacing([rem(2.4), rem(2), rem(2)], [10, 5, 5]);

export const StyledDetails = styled('details')`
    width: 100%;
    padding: ${detailsPadding};
    cursor: pointer;
    & ::-webkit-details-marker {
        display: none;
    }
`;

export const StyledSummary = styled('summary')`
    list-style: none;
`;

export const StyledContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledHeading = styled('p')`
    ${({ theme }: { theme: Theme }) => `
    margin: ${theme.tggSpacing(0, 0)};
    text-transform:${theme.isRebranding('lowercase', 'unset')};
    color: ${theme.getRebrandingColor(
        theme.palette.common.blue,
        theme.palette.tgg.text.label,
    )};
    `}
    ${({ theme }: { theme: Theme }) =>
        theme.isRebranding(
            theme.typography.text_14_bold,
            theme.typography.bodyStandardBoldRebrand,
        )};
`;
